import React from "react";
import styles from "./loader.module.css";


function Loader({ black=false }) {

  return (
    <div className={`${black ? styles.containerBlack : styles.container}`}>
      <span className={styles.loader}/>
    </div>
  );
}

export default Loader;
